module.exports = __webpack_public_path__ + "492858ba6dc41efb95c0a4ffd0e752a8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/reading/log-reading.png
// module id = 337
// module chunks = 0